export const MATERIAS_PENDIENTES = [
  { codigo: 'MAT-1', nombre: 'Biología', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-2', nombre: 'Dibujo', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-3', nombre: 'Física', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-4', nombre: 'Filosofía', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-5', nombre: 'Historia', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-6', nombre: 'Inglés', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-7', nombre: 'Literatura', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-8', nombre: 'Matemática', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-9', nombre: 'Química', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-93', nombre: 'Educación Física', grado: 'Cuarto año', anio: '4to', orientacion: '' },
  { codigo: 'MAT-94', nombre: 'Astronomía', grado: 'Cuarto año', anio: '4to', orientacion: '' },

  { codigo: 'MAT-20', nombre: 'Matemática', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-21', nombre: 'Historia', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-22', nombre: 'Sociología', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-23', nombre: 'Italiano', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-24', nombre: 'Literatura', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-25', nombre: 'Filosofía', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-26', nombre: 'Inglés', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-96', nombre: 'Educación Ciudadana', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-102', nombre: 'Geografía', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },
  { codigo: 'MAT-103', nombre: 'Biología', grado: 'Quinto año', anio: '5to', orientacion: 'Humanístico' },

  { codigo: 'MAT-10', nombre: 'Matemática A', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-11', nombre: 'Matemática B', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-12', nombre: 'Física', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-13', nombre: 'Química', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-71', nombre: 'Filosofía', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-72', nombre: 'Inglés', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-73', nombre: 'Dibujo', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-90', nombre: 'Educación Ciudadana', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },
  { codigo: 'MAT-120', nombre: 'Literatura', grado: 'Quinto año', anio: '5to', orientacion: 'Científico' },

  { codigo: 'MAT-14', nombre: 'Matemática', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-15', nombre: 'Física', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-16', nombre: 'Dibujo', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-17', nombre: 'Literatura', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-18', nombre: 'Filosofía', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-19', nombre: 'Inglés', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-70', nombre: 'Biología', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-75', nombre: 'Química', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },
  { codigo: 'MAT-95', nombre: 'Educación Ciudadana', grado: 'Quinto año', anio: '5to', orientacion: 'Biológico' },

  { codigo: 'MAT-79', nombre: 'Historia del Arte', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-80', nombre: 'Expresión Musical', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-81', nombre: 'Expresión Corporal y Teatro', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-82', nombre: 'Comunicación Visual I', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-83', nombre: 'Física', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-97', nombre: 'Educación Ciudadana', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-98', nombre: 'Matemática', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-99', nombre: 'Inglés', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-100', nombre: 'Literatura', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },
  { codigo: 'MAT-101', nombre: 'Filosofía', grado: 'Quinto año', anio: '5to', orientacion: 'Artístico' },

  { codigo: 'MAT-41', nombre: 'Física', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-42', nombre: 'Química', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-43', nombre: 'Filosofía', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-44', nombre: 'Inglés', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-45', nombre: 'Derecho', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-46', nombre: 'Biología', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-47', nombre: 'Matemática', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-118', nombre: 'Estudios Económicos y Sociales', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },
  { codigo: 'MAT-119', nombre: 'Literatura', grado: 'Sexto año', anio: '6to', orientacion: 'Medicina' },

  { codigo: 'MAT-29', nombre: 'Filosofía', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-34', nombre: 'Física', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-35', nombre: 'Química', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-37', nombre: 'Inglés', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-38', nombre: 'Matemática A', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-39', nombre: 'Matemática B', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-40', nombre: 'Matemática C', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-116', nombre: 'Estudios Económicos y Sociales', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },
  { codigo: 'MAT-117', nombre: 'Literatura', grado: 'Sexto año', anio: '6to', orientacion: 'Ingeniería' },

  { codigo: 'MAT-55', nombre: 'Historia', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-56', nombre: 'Contabilidad', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-57', nombre: 'Filosofía', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-58', nombre: 'Inglés', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-59', nombre: 'Literatura', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-60', nombre: 'Dibujo', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-61', nombre: 'Matemática B', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-62', nombre: 'Matemática A', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-92', nombre: 'Economía', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },
  { codigo: 'MAT-115', nombre: 'Estudios Económicos y Sociales', grado: 'Sexto año', anio: '6to', orientacion: 'Economía' },

  { codigo: 'MAT-48', nombre: 'Historia', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-49', nombre: 'Contabilidad', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-50', nombre: 'Filosofía', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-51', nombre: 'Inglés', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-52', nombre: 'Literatura', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-53', nombre: 'Derecho', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-54', nombre: 'Italiano', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-76', nombre: 'Matemática', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-113', nombre: 'Economía', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },
  { codigo: 'MAT-114', nombre: 'Estudios Económicos y Sociales', grado: 'Sexto año', anio: '6to', orientacion: 'Derecho' },

  { codigo: 'MAT-84', nombre: 'Historia del Arte', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-85', nombre: 'Lenguaje, Comunicación y Medios Audiovisuales', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-86', nombre: 'Teatro', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-87', nombre: 'Práctica y Expresión Musical', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-88', nombre: 'Expresión Corporal y Danza', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-89', nombre: 'Arte y Comunicación Visual II', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-109', nombre: 'Estudios Económicos y Sociales', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-110', nombre: 'Literatura', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-111', nombre: 'Filosofía', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },
  { codigo: 'MAT-112', nombre: 'Inglés', grado: 'Sexto año', anio: '6to', orientacion: 'Arte y Expresión' },

  { codigo: 'MAT-27', nombre: 'Física', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-28', nombre: 'Dibujo', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-30', nombre: 'Inglés', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-31', nombre: 'Literatura', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-32', nombre: 'Matemática', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-33', nombre: 'Historia del Arte', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-36', nombre: 'Filosofía', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-107', nombre: 'Matemática IV', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },
  { codigo: 'MAT-108', nombre: 'Estudios Económicos y Sociales', grado: 'Sexto año', anio: '6to', orientacion: 'Arquitectura' },

  { codigo: 'MAT-63', nombre: 'Matemática', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-64', nombre: 'Filosofía', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-65', nombre: 'Inglés', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-66', nombre: 'Geología', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-67', nombre: 'Física', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-68', nombre: 'Química', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-69', nombre: 'Botánica', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-91', nombre: 'Estudios Económicos y Sociales', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-104', nombre: 'Biología', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-105', nombre: 'Recursos naturales y Paisaje Agrario', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' },
  { codigo: 'MAT-106', nombre: 'Literatura', grado: 'Sexto año', anio: '6to', orientacion: 'Agronomía' }
];

export const normalizeMateriaValue = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

export const parseCantidadPendientes = (valor) => {
  if (valor === '8 o más') return 8;
  if (valor === 'Más de 8') return 9;
  if (/^No cursé (4to|5to|6to) año aún$/.test(valor) || valor === 'No empecé') return 6;
  if (valor === 'No recuerdo exactamente' || valor === 'No lo recuerdo exactamente') return 0;
  return parseInt(valor, 10) || 0;
};

export const getMateriasPorAnioOrientacion = (anio, orientacion = '') => {
  const normalizedAnio = normalizeMateriaValue(anio);
  const normalizedOrientacion = normalizeMateriaValue(orientacion);

  return MATERIAS_PENDIENTES.filter((materia) => {
    if (normalizeMateriaValue(materia.anio) !== normalizedAnio) return false;
    if (normalizedAnio === '4to') return true;
    return normalizeMateriaValue(materia.orientacion) === normalizedOrientacion;
  });
};

export const getMateriaByCodigo = (codigo) =>
  MATERIAS_PENDIENTES.find((materia) => materia.codigo === codigo) || null;

export const getMateriasSeleccionadasList = (materiasSeleccionadas) => {
  if (!materiasSeleccionadas) return [];

  if (Array.isArray(materiasSeleccionadas)) {
    return materiasSeleccionadas.filter(Boolean);
  }

  return Object.values(materiasSeleccionadas)
    .flatMap((materias) => (Array.isArray(materias) ? materias : []))
    .filter(Boolean);
};

export const getMateriasSeleccionadasTexto = (materiasSeleccionadas) => {
  const materias = getMateriasSeleccionadasList(materiasSeleccionadas);
  if (!materias.length) return '-';

  return materias
    .map((materia) => {
      if (typeof materia === 'string') return materia;
      const anio = materia.anio ? `${materia.anio}: ` : '';
      const codigo = materia.codigo ? ` (${materia.codigo})` : '';
      return `${anio}${materia.nombre || ''}${codigo}`.trim();
    })
    .filter(Boolean)
    .join(' | ');
};
